import { createAction } from '@ngrx/store';

export const clearFilters = createAction('[Filters] Clear Filters');
